import { render, staticRenderFns } from "./brand-logo.vue?vue&type=template&id=e8eac21e"
import script from "./brand-logo.vue?vue&type=script&lang=js"
export * from "./brand-logo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports